import { gql } from '@apollo/client';
import type { SerializedHardwarePackage } from '@enmon/commons/lib/tools';

export const GET_HARDWARE_PACKAGE_DATA = gql`
  query getHardwarePackage($id: ID) {
    hardwarePackage(id: $id) {
      data {
        id
        attributes {
          name
          query
        }
      }
    }
  }
`;

export type HardwarePackageDataItem = Pick<SerializedHardwarePackage, 'id' | 'name' | 'query'>;

export interface HardwarePackageData {
  hardwarePackage: {
    data: HardwarePackageDataItem;
  };
}
